import { Link } from 'react-router';
import { Phone, Mail } from 'lucide-react';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.asetquhub.app';
const APP_STORE_URL = 'https://apps.apple.com/id/app/asetqu-hub/id6761657212?l=id';

const DesktopFooter = () => {
  return (
    <footer className='bg-gradient-to-r from-[#163eb7] to-[#009691] text-white'>
      <div className='max-w-[1280px] mx-auto px-8 py-12 grid grid-cols-1 md:grid-cols-[1.3fr_0.9fr_1.3fr] gap-10'>
        <div>
          <div className='flex items-center gap-3'>
            <img src='/logo-asetquhub-white.png' alt='AsetQu Hub' className='w-10 h-10' />
            <h3 className='text-lg font-bold'>AsetQu HUB</h3>
          </div>
          <p className='text-sm text-white/80 mt-4 max-w-md'>
            Lakukan transaksi jual beli, lelang, dan investasikan aset properti dengan aman
            menggunakan token AsetQu.
          </p>
          <div className='flex items-center gap-3 mt-5'>
            <a
              className='w-9 h-9 rounded-full bg-white/10 flex items-center justify-center'
              href='https://www.facebook.com/profile.php?profile.php?id=61577121005275id=61577121005275'
            >
              <img src='/icon/icon-facebook.png' alt='Facebook' className='w-4 h-4' />
            </a>
            <a
              className='w-9 h-9 rounded-full bg-white/10 flex items-center justify-center'
              href='https://www.instagram.com/asetqu_official'
            >
              <img src='/icon/icon-instagram.png' alt='Instagram' className='w-4 h-4' />
            </a>
            <a
              className='w-9 h-9 rounded-full bg-white/10 flex items-center justify-center'
              href='https://x.com/asetquu'
            >
              <img src='/icon/icon-x-twitter.png' alt='X' className='w-4 h-4' />
            </a>
          </div>
          <p className='text-xs text-white/70 mt-6'>
            © AsetQu Hub, {new Date().getFullYear()}. All Rights Reserved.
          </p>
          <div className='flex items-center gap-4 mt-6'>
            <a href={PLAY_STORE_URL} target='_blank' rel='noopener noreferrer'>
              <img src='/play-store.png' alt='Google Play' className='h-10 w-auto' />
            </a>
            <a href={APP_STORE_URL} target='_blank' rel='noopener noreferrer'>
              <img src='/app-store.png' alt='App Store' className='h-10 w-auto' />
            </a>
          </div>
        </div>

        <div>
          <h4 className='text-sm font-bold uppercase tracking-wider'>Links</h4>
          <div className='mt-4 space-y-3 text-sm text-white/80'>
            <Link to='/propribid' className='block hover:text-white'>
              Propribid
            </Link>
            <Link to='/proprimarket' className='block hover:text-white'>
              Proprimarket
            </Link>
            <Link to='/proprivoucher' className='block hover:text-white'>
              Proprivoucher
            </Link>
            <Link to='/academy' className='block hover:text-white'>
              Aset Academy
            </Link>
          </div>
        </div>

        <div>
          <h4 className='text-sm font-bold uppercase tracking-wider'>Contact</h4>
          <div className='mt-4 space-y-4 text-sm text-white/80'>
            <div className='flex items-start gap-3'>
              <img src='/icon/icon-maps.png' alt='Maps' className='w-4 h-4 mt-0.5' />
              <span>
                Menara Kadin LT 17 Unit B&C Jl. H.R. Rasuna Said Blok X-5 No.Kav.2-3 Kota Jakarta
                Selatan, Daerah Khusus Ibukota Jakarta 12950
              </span>
            </div>
            <div className='flex items-center gap-3'>
              <Phone size={16} />
              <span>+62852 8599 5260</span>
            </div>
            <div className='flex items-center gap-3'>
              <Mail size={16} />
              <span>support@asetquhub.id</span>
            </div>
          </div>
        </div>
      </div>

      <div className='border-t border-white/10'>
        <div className='max-w-[1280px] mx-auto px-8 py-4 flex flex-col md:flex-row items-center justify-between text-xs text-white/70 gap-3'>
          <span>© {new Date().getFullYear()} AsetQu Hub. All rights reserved.</span>
          <div className='flex items-center gap-4'>
            <Link
              to='https://asetquhub.com/privacy-policy'
              target='_blank'
              className='hover:text-white'
            >
              Privacy Policy
            </Link>
            <Link
              to='https://asetquhub.com/terms-of-service'
              target='_blank'
              className='hover:text-white'
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DesktopFooter;
